import React from "react";
import { nFormatter } from "utils/currencyFormat";

const choVayConst = {
  KieuLaiSuat: {
    LaiTrieuNgay: 1,
    LaiTongNgay: 2,
    LaiThang: 3,
    LaiKy: 4,
    LaiPhanTramDinhKy: 5,
    LaiTuan: 6,
    LaiPhanTramTuan: 7,
  },
  KieuLaiSuatText: {
    1: "Lãi/triệu/ngày",
    2: "Lãi ngày",
    3: "Lãi tháng",
    4: "Lãi kỳ",
    5: "Lãi % định kỳ",
    6: "Lãi tuần",
    7: "Lãi % tuần",
  },
  KieuLaiSuatPlaceholder: {
    1: "2,000",
    2: "2,000",
    3: "%",
    4: "2,000",
    5: "%",
    6: "2,000",
    7: "%",
  },
  KieuLaiSuatDisplay: {
    1: "/1 triệu",
    2: "/ngày",
    3: "%/tháng",
    4: "/kỳ",
    5: "%/kỳ",
    6: "/tuần",
    7: "%/tuần",
  },
  Status: {
    XoaKhoiHeThong: -2,
    Deleted: -1,
    Open: 1,
    Close: 2,
    No: 3,
    QuaHan: 4,
    ChoDuyet: 5,
    ChoNhanTien: 6,
  },
  StatusText: {
    "-2": "Xóa khỏi hệ thống",
    "-1": "Xóa",
    0: "Đủ lãi",
    1: "Đủ lãi",
    2: "Đóng",
    3: "Nợ",
    4: "Quá hạn",
    5: "Chờ duyệt",
    6: "Chờ nhận tiền",
  },
  StatusHoText: {
    "-2": "Xóa khỏi hệ thống",
    "-1": "Xóa",
    0: "Đủ họ",
    1: "Đủ họ",
    2: "Đóng",
    3: "Nợ",
    4: "Quá hạn",
    5: "Chờ duyệt",
    6: "Chờ nhận tiền",
    50: "Nợ xấu",
    20: "Nợ rủi ro",
    10: "Chú ý",
    15: "Quá Hạn",
  },
  Type: { None: -1, VayThuong: 1, VayHo: 2, CamDo: 3, VayGop: 4 },
  TypeText: {
    "-1": "",
    1: "Tín chấp",
    2: "Trả góp",
    3: "Cầm đồ",
  },
  TypePaid: { None: -1, Ngay: 1, Thang: 2, ThangDinhKy: 3 },
  BeforeAfter: { None: -1, After: 1, Before: 2 },
  BeforeAfterText: { "-1": "", 1: "Sau", 2: "Trước" },
  DebtLevel: { None: -1, Normal: 0, Bad: 2, Risk: 3, Progress: 4 },
  DebtLevelText: {
    "-1": "Bình thường",
    null: "Bình thường",
    0: "Bình thường",
    1: "Bình thường",
    50: "Nợ xấu",
    20: "Nợ rủi ro",
    4: "Bị xử lý",
    10: "Chú ý",
    15: "Quá Hạn",
  },
  DebtLevelText1: {
    "-1": "Bình thường",
    null: "Bình thường",
    0: "Bình thường",
    1: "Bình thường",
    2: "Bình thường 2",
    3: "Bình thường 3",
    5: "Bình thường 5",
    20: "Nợ rủi ro",
    30: "Nợ R2",
    40: "Nợ R3",
    50: "Nợ xấu",
    10: "Chú ý",
    15: "Quá Hạn",
  },
  DebtLevelColor: {
    "-1": "home-new-blue",
    null: "home-new-blue",
    0: "debtlevel-xanh",
    1: "debtlevel-xanh",
    2: "red",
    3: "debtlevel-yellow",
    4: "debtlevel-do",
    10: "debtlevel-yellow",
    15: "debtlevel-yellow",
  },
};

export const ChoVayCombo = {
  StatusDefault: "- Trạng thái -",
  HopDongCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Có tài sản" },
    { value: "2", label: "Không có tài sản" },
  ],
  StatusCombo: [
    { value: "0", label: "Tất cả" },
    { value: "5", label: "Đang vay" },
    { value: "1", label: "Đủ lãi" },
    { value: "3", label: "Nợ" },
    { value: "4", label: "Quá hạn" },
    { value: "2", label: "Đóng" },
  ],
  StatusComboLaiHo: [
    { value: "0", label: "Tất cả" },
    { value: "5", label: "Đang vay" },
    { value: "1", label: "Đủ họ" },
    { value: "3", label: "Nợ" },
    { value: "4", label: "Quá hạn" },
    { value: "2", label: "Đóng" },
  ],
  TinhTrangDefault: "- Tình trạng -",
  TinhTrangCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Bình thường" },
    { value: "50", label: "Nợ xấu" },
    { value: "20", label: "Nợ rủi ro" },
  ],
  TinhTrangCombo1: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Bình thường" },
    { value: "2", label: "Bình thường 2" },
    { value: "3", label: "Bình thường 3" },
    { value: "5", label: "Bình thường 5" },
    { value: "10", label: "Chú ý" },
    { value: "15", label: "Quá hạn" },
    { value: "20", label: "Nợ rủi ro" },
    { value: "30", label: "Nợ R2" },
    { value: "40", label: "Nợ R3" },
    { value: "50", label: "Nợ xấu" },
  ],
  ThoiGianDefault: "- Thời gian -",
  ThoiGianCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Hôm nay" },
    { value: "5", label: "Hôm qua" },
    { value: "2", label: "Tuần này" },
    { value: "3", label: "Tháng này" },
    { value: "4", label: "Năm nay" },
  ],
  KieuVayDefault: "- Kiểu vay -",
  KieuVayCombo: [
    { value: "0", label: "Tất cả" },
    { value: "3", label: "Cầm đồ" },
    { value: "1", label: "Tín chấp" },
    { value: "2", label: "Trả góp" },
  ],
  KieuVayCombo1: [
    { value: "0", label: "Tất cả" },

    { value: "1", label: "Tín chấp" },
    { value: "2", label: "Trả góp" },
    { value: "3", label: "Cầm đồ" },
    { value: "5", label: "Bán hàng trả góp" },
  ],
  NgayTraDefault: "- Ngày phải trả -",
  NgayTraCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Hôm nay" },
    { value: "2", label: "Hôm qua" },
    { value: "3", label: "Ngày mai" },
    { value: "4", label: "Khác" },
  ],
  SapXepDefault: "- Sắp xếp -",
  SapXepCombo: [
    { value: "0", label: "Sắp xếp mặc định" },
    { value: "1", label: "Nợ nhiều nhất" },
    { value: "2", label: "Nợ lâu nhất" },
    { value: "3", label: "A > Z" },
  ],
  TinhTrangTraDefault: "- Tình trạng trả -",
  TinhTrangTraCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Không gia hạn" },
    { value: "2", label: "Gia hạn" },
  ],
  NgayPhaiTraDefault: "- Ngày phải trả -",
  NgayPhaiTraCombo: [
    { value: "0", label: "Hôm nay" },
    { value: "1", label: "Ngày mai" },
    { value: "2", label: "Đang nợ" },
    { value: "3", label: "Trả gốc hôm nay" },
    { value: "4", label: "Quá hạn trả gốc" },
  ],
  NgayPhaiTraCombo1: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Hôm nay" },
    { value: "3", label: "Ngày mai" },
    { value: "2", label: "Đang nợ" },
    { value: "4", label: "Trả gốc hôm nay" },
    { value: "5", label: "Quá hạn trả gốc" },
  ],

  DoiTacDefault: "- Đối tác -",
  DoiTacCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Chủ nợ" },
    { value: "2", label: "Khách hàng" },
  ],
  NguonKhachHangDefault: "- Đối tác -",
  NguonKhachHangCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Facebook" },
  ],
  TrangThaiVayDefault: "- Đối tác -",
  TrangThaiVayCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Đang vay" },
    { value: "2", label: "Kết thúc" },
    { value: "3", label: "Chưa có hợp đồng" },
  ],
  TrangThaiHoatDongDefault: "- Trạng thái hoạt động -",
  TrangThaiHoatDongCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Đang hoạt động" },
    { value: "2", label: "Tạm ngừng" },
  ],

  TrangThaiHoatDongDefault: "- Trạng thái hoạt động -",
  TrangThaiHoatDongCuaHangCombo: [
    { value: "10", label: "Tất cả" },
    { value: "1", label: "Đang hoạt động" },
    { value: "0", label: "Tạm ngừng" },
  ],

  KhoDefault: "- Kho -",
  KhoCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Kho 1" },
    { value: "2", label: "Kho 2" },
  ],
  TrangThaiTaiSanDefault: "- Trạng thái -",
  TrangThaiTaiSanCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Đã thanh lý" },
    { value: "2", label: "Đang cầm đồ" },
    { value: "3", label: "Cần thanh lý" },
    { value: "4", label: "Đang cho thuê" },
    { value: "5", label: "Sở hữu" },
    { value: "6", label: "Cầm nhận vay" },
    { value: "7", label: "Đã trả" },
    { value: "8", label: "Cần thu hồi" },
    { value: "9", label: "Cần chuộc đồ" },
    { value: "10", label: "Nhập hàng" },
    { value: "11", label: "Bán hàng" },
  ],
  TrangThaiKhoDefault: "- Trạng thái -",
  TrangThaiKhoCombo: [
    { value: "", label: "Tất cả" },
    { value: "1", label: "Còn chỗ" },
    { value: "0", label: "Hết chỗ" },
  ],
  TrangThaiKiemDefault: "- Trạng thái -",
  TrangThaiKiemCombo: [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Chưa kiểm" },
    { value: "2", label: "Đã kiểm" },
  ],
};
export function LaiSuatText(laiSuat, KieuLaiSuat) {
  var laiSuat1 = 0;
  if (KieuLaiSuat == null || KieuLaiSuat == undefined) return 0;

  let laiSuatHT = laiSuat.laiSuat;
  if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiThang)
    laiSuat1 =
      laiSuatHT && parseFloat(laiSuatHT) > 0 ? laiSuatHT : laiSuat.Phantram;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiTongNgay)
    laiSuat1 = nFormatter(
      laiSuatHT && parseFloat(laiSuatHT) > 0 ? laiSuatHT : laiSuat.LaiNgayTong
    );
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiKy)
    laiSuat1 = nFormatter(
      laiSuatHT && parseFloat(laiSuatHT) > 0 ? laiSuatHT : laiSuat.LaiNgayTong
    );
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramDinhKy)
    laiSuat1 =
      laiSuatHT && parseFloat(laiSuatHT) > 0 ? laiSuatHT : laiSuat.Phantram;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramTuan)
    laiSuat1 = laiSuat.Phantram;
  else
    laiSuat1 = nFormatter(
      laiSuatHT && parseFloat(laiSuatHT) > 0 ? laiSuatHT : laiSuat.LaiNgay
    );
  return laiSuat1 + choVayConst.KieuLaiSuatDisplay[KieuLaiSuat];
}
export function LaiSuatText2(laiSuat, KieuLaiSuat) {
  var laiSuat1 = 0;
  let textDisplay = "";
  if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiThang) {
    laiSuat1 = laiSuat.Phantram;
    textDisplay = "%";
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiTongNgay) {
    textDisplay = "đ";
    laiSuat1 = laiSuat.LaiNgayTong;
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiKy) {
    laiSuat1 = laiSuat.LaiNgayTong;
    textDisplay = "đ";
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramDinhKy) {
    laiSuat1 = laiSuat.Phantram;
    textDisplay = "%";
  } else if (KieuLaiSuat == choVayConst.KieuLaiSuat.LaiTuan) {
    laiSuat1 = laiSuat.LaiNgayTong;
    textDisplay = "đ";
  } else if (KieuLaiSuat == choVayConst.KieuLaiSuat.LaiPhanTramTuan) {
    laiSuat1 = laiSuat.Phantram;
    textDisplay = "%";
  } else {
    laiSuat1 = laiSuat.LaiNgay;
    textDisplay = "đ";
  }
  return laiSuat1 + textDisplay;
}

export function LaiSuatText3(laiSuat, KieuLaiSuat) {
  var laiSuat1 = 0;
  if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiThang) {
    laiSuat1 = laiSuat.Phantram;
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiTongNgay) {
    laiSuat1 = laiSuat.LaiNgayTong;
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiKy) {
    laiSuat1 = laiSuat.LaiNgayTong;
  } else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramDinhKy) {
    laiSuat1 = laiSuat.Phantram;
  } else if (KieuLaiSuat == choVayConst.KieuLaiSuat.LaiTuan) {
    laiSuat1 = laiSuat.LaiNgayTong;
  } else if (KieuLaiSuat == choVayConst.KieuLaiSuat.LaiPhanTramTuan) {
    laiSuat1 = laiSuat.Phantram;
  } else {
    laiSuat1 = laiSuat.LaiNgay;
  }
  return laiSuat1;
}

export function getLaiSuat(chovay, KieuLaiSuat) {
  var laiSuat1 = 0;
  if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiThang)
    laiSuat1 = chovay.Phantram;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiTongNgay)
    laiSuat1 = chovay.LaiNgayTong;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiKy)
    laiSuat1 = chovay.LaiNgayTong;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramDinhKy)
    laiSuat1 = chovay.Phantram;
  else if (KieuLaiSuat === choVayConst.KieuLaiSuat.LaiPhanTramTuan)
    laiSuat1 = chovay.Phantram;
  else laiSuat1 = chovay.LaiNgay;
  if (chovay.laiSuat && parseFloat(chovay.laiSuat) > 0)
    laiSuat1 = chovay.laiSuat;
  return laiSuat1;
}
//LoaiTinhLai: 1: Bình thường , 2: Kiểu tính gốc lãi, 3: dư nợ giảm dần
export function bindKieuLaiSuat(objConfig, methodInterest, LoaiTinhLai) {
  methodInterest = parseInt(methodInterest);
  let {
    _laiTrieuNgayTinChapCamDoNgay,
    _laiNgayTinChapCamDoNgay,
    _laiThangTinChapCamDoNgay,
    _laiKyTinChapCamDoNgay,
    _laiPhanTramKyTinChapCamDoNgay,
    _laiNgayTinChapCamDoThang,
    _laiTrieuNgayTinChapCamDoThang,
    _laiThangTinChapCamDoThang,
    _laiTuanTinChapCamDoTuan,
    _laiPhanTramTuanTinChapCamDoTuan,
  } = objConfig;
  let model = [];
  if (LoaiTinhLai != 3) {
    if (
      (methodInterest === 1 && _laiTrieuNgayTinChapCamDoNgay) ||
      (methodInterest === 2 && _laiTrieuNgayTinChapCamDoThang)
    ) {
      model.push(<option value="1">Lãi/triệu/ngày </option>);
    }
  }
  if (
    (methodInterest === 1 && _laiThangTinChapCamDoNgay) ||
    (methodInterest === 2 && _laiThangTinChapCamDoThang)
  ) {
    model.push(<option value="3">Lãi%/tháng</option>);
  }
  if (LoaiTinhLai != 2 && LoaiTinhLai != 3) {
    if (
      (methodInterest === 1 && _laiNgayTinChapCamDoNgay) ||
      (methodInterest === 2 && _laiNgayTinChapCamDoThang)
    ) {
      model.push(<option value="2">Lãi/Ngày</option>);
    }
    if (methodInterest === 1 && _laiKyTinChapCamDoNgay) {
      model.push(<option value="4">Lãi kỳ</option>);
    }

    if (methodInterest === 1 && _laiPhanTramKyTinChapCamDoNgay) {
      model.push(<option value="5">Lãi % định kỳ</option>);
    }

    if (methodInterest === 4 && _laiTuanTinChapCamDoTuan) {
      model.push(<option value="6">Lãi tuần</option>);
    }
    if (methodInterest === 4 && _laiPhanTramTuanTinChapCamDoTuan) {
      model.push(<option value="7">Lãi %/tuần</option>);
    }
  }

  return model;
}
//LoaiTinhLai: 1: Bình thường , 2: Kiểu tính gốc lãi, 3: dư nợ giảm dần
export function bindListKieuLaiSuat(objConfig, methodInterest, LoaiTinhLai) {
  methodInterest = parseInt(methodInterest);
  let {
    _laiTrieuNgayTinChapCamDoNgay,
    _laiNgayTinChapCamDoNgay,
    _laiThangTinChapCamDoNgay,
    _laiKyTinChapCamDoNgay,
    _laiPhanTramKyTinChapCamDoNgay,
    _laiNgayTinChapCamDoThang,
    _laiTrieuNgayTinChapCamDoThang,
    _laiThangTinChapCamDoThang,
    _laiTuanTinChapCamDoTuan,
    _laiPhanTramTuanTinChapCamDoTuan,
  } = objConfig;
  let model = [];
  if (LoaiTinhLai != 3) {
    if (
      (methodInterest === 1 && _laiTrieuNgayTinChapCamDoNgay) ||
      (methodInterest === 2 && _laiTrieuNgayTinChapCamDoThang)
    ) {
      model.push({ value: "1", label: "Lãi/triệu/ngày" });
    }
  }
  if (
    (methodInterest === 1 && _laiThangTinChapCamDoNgay) ||
    (methodInterest === 2 && _laiThangTinChapCamDoThang)
  ) {
    model.push({ value: "3", label: "Lãi%/tháng" });
  }
  if (LoaiTinhLai != 2 && LoaiTinhLai != 3) {
    if (
      (methodInterest === 1 && _laiNgayTinChapCamDoNgay) ||
      (methodInterest === 2 && _laiNgayTinChapCamDoThang)
    ) {
      model.push({ value: "2", label: "Lãi/Ngày" });
    }
    if (methodInterest === 1 && _laiKyTinChapCamDoNgay) {
      model.push({ value: "4", label: "Lãi kỳ" });
    }

    if (methodInterest === 1 && _laiPhanTramKyTinChapCamDoNgay) {
      model.push({ value: "5", label: "Lãi % định kỳ" });
    }

    if (methodInterest === 4 && _laiTuanTinChapCamDoTuan) {
      model.push({ value: "6", label: "Lãi tuần" });
    }
    if (methodInterest === 4 && _laiPhanTramTuanTinChapCamDoTuan) {
      model.push({ value: "7", label: "Lãi %/tuần" });
    }
  }

  return model;
}
//Luôn giữ option đang chọn để hợp đồng cũ không bị mất giá trị khi cấu hình đã tắt
export function bindKieuLaiSuatNhanVay(objConfig, typePaid, current) {
  const ky = parseInt(typePaid) === 2 ? "Thang" : "Ngay";
  const hienThi = (field, value) =>
    !objConfig || objConfig[`${field}_${ky}Enabled`] || parseInt(current) === value;
  let model = [];
  if (hienThi("LaiTrieuNgay", 1))
    model.push(<option value="1">Lãi/triệu/ngày </option>);
  if (hienThi("LaiNgay", 2)) model.push(<option value="2">Lãi/Ngày</option>);
  if (hienThi("LaiThang", 3)) model.push(<option value="3">Lãi%/tháng</option>);
  return model;
}

export function bindTypePaidNhanVay(objConfig, current) {
  const hienThi = (enabled, value) => enabled || parseInt(current) === value;
  let model = [];
  if (hienThi(objConfig.KyDongLaiNgayEnabled, 1))
    model.push(<option value="1">Ngày</option>);
  if (hienThi(objConfig.KyDongLaiThangDinhKyEnabled, 3))
    model.push(<option value="3">Tháng định kỳ</option>);
  if (hienThi(objConfig.KyDongLaiThangEnabled, 2))
    model.push(<option value="2">Tháng</option>);
  return model;
}

//LoaiTinhLai: 1: Bình thường , 2: Kiểu tính gốc lãi, 3: dư nợ giảm dần
export function bindTypePaid(objConfig, LoaiTinhLai) {
  let {
    _kyDongLaiTinChapCamDoNgay,
    _kyDongLaiTinChapCamDoThang,
    _kyDongLaiTinChapCamDoThangDinhKy,
    _kyDongLaiTinChapCamDoTuan,
  } = objConfig;
  let model = [];
  if (LoaiTinhLai != 3) {
    if (_kyDongLaiTinChapCamDoNgay) {
      model.push(<option value="1">Ngày</option>);
    }
  }
  if (LoaiTinhLai != 2 && LoaiTinhLai != 3) {
    if (_kyDongLaiTinChapCamDoTuan) {
      model.push(<option value="4">Tuần</option>);
    }
    if (_kyDongLaiTinChapCamDoThangDinhKy) {
      model.push(<option value="3">Tháng định kỳ</option>);
    }
  }
  if (_kyDongLaiTinChapCamDoThang) {
    model.push(<option value="2">Tháng</option>);
  }

  return model;
}
export default choVayConst;
